import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import EVENT_TRANSLATIONS, { LANGS } from "@event/i18n";

export { LANGS };

const BASE_TRANSLATIONS = {
  ru: {
    nav: { program: "Программа", speakers: "Спикеры", gallery: "Фото", pricing: "Билеты", buy: "Купить билет", contact: "Контакт" },
    footer: {
      contacts: "Контакты",
      docs: "Документы",
      refund: "Политика возврата",
      terms: "Условия участия",
      privacy: "Политика конфиденциальности",
      made: "Сделано с любовью к нетворкингу.",
    },
    modal: {
      title: "Регистрация на конференцию",
      desc: "Заполните данные — после оплаты вы попадёте в закрытый чат участников.",
      l_name: "Имя и Фамилия", p_name: "Иван Ковальский",
      l_phone: "Телефон", p_phone: "+48 600 000 000",
      l_tg: "Telegram @username", p_tg: "@username", help_tg: "Нужен для добавления в закрытый чат участников.",
      l_ticket: "Категория билета",
      total: "Итого",
      pay_note: "Оплата картой через Stripe. Безопасно и зашифровано.",
      agree: "Я согласен с условиями участия, политикой возврата и обработкой персональных данных.",
      pay_btn: "Перейти к безопасной оплате",
      pay_loading: "Переход к оплате...",
      err_name: "Укажите имя и фамилию",
      err_phone: "Введите корректный номер телефона",
      err_tg: "Укажите Telegram @username",
      err_agree: "Подтвердите согласие с политикой",
      err_generic: "Что-то пошло не так",
    },
    toasts: {
      cancel: "Оплата отменена. Попробуйте ещё раз.",
      success: "Оплата успешна! До встречи на конференции 🎉",
      expired: "Сессия оплаты истекла. Попробуйте снова.",
      check: "Проверяем статус оплаты...",
      manual: "Не удалось подтвердить оплату автоматически. Проверьте email.",
    },
    lang: { label: "Язык" },
    contact: {
      eyebrow: "Связаться",
      title: "Свяжитесь с нами",
      l_name: "Имя и фамилия",
      p_name: "Иван Ковальский",
      l_phone: "Телефон",
      p_phone: "+48 600 000 000",
      l_email: "Email",
      p_email: "ivan@example.com",
      l_message: "Вопрос / комментарий",
      p_message: "Ваш вопрос...",
      submit: "Отправить",
      success: "Сообщение отправлено! Мы свяжемся с вами.",
    },
    cookies: {
      text: "Мы используем cookies для улучшения работы сайта.",
      accept: "Принять",
      decline: "Отклонить",
    },
  },

  en: {
    nav: { program: "Program", speakers: "Speakers", gallery: "Photos", pricing: "Tickets", buy: "Get ticket", contact: "Contact" },
    footer: {
      contacts: "Contacts",
      docs: "Documents",
      refund: "Refund Policy",
      terms: "Terms & Conditions",
      privacy: "Privacy Policy",
      made: "Built with a love of networking.",
    },
    modal: {
      title: "Conference registration",
      desc: "Fill in the details — after payment you’ll join the private attendees chat.",
      l_name: "Full Name", p_name: "John Smith",
      l_phone: "Phone", p_phone: "+48 600 000 000",
      l_tg: "Telegram @username", p_tg: "@username", help_tg: "Required to add you to the private attendees chat.",
      l_ticket: "Ticket category",
      total: "Total",
      pay_note: "Card payment via Stripe. Safe and encrypted.",
      agree: "I agree to the terms, refund policy and processing of personal data.",
      pay_btn: "Proceed to secure payment",
      pay_loading: "Redirecting to payment...",
      err_name: "Please enter your full name",
      err_phone: "Please enter a valid phone number",
      err_tg: "Please enter your Telegram @username",
      err_agree: "Please accept the policy",
      err_generic: "Something went wrong",
    },
    toasts: {
      cancel: "Payment cancelled. Please try again.",
      success: "Payment successful! See you at the conference 🎉",
      expired: "Payment session expired. Please try again.",
      check: "Checking payment status...",
      manual: "Could not auto-confirm payment. Please check your email.",
    },
    lang: { label: "Language" },
    contact: {
      eyebrow: "Get in touch",
      title: "Contact us",
      l_name: "Full name",
      p_name: "John Smith",
      l_phone: "Phone",
      p_phone: "+48 600 000 000",
      l_email: "Email",
      p_email: "john@example.com",
      l_message: "Question / comment",
      p_message: "Your question...",
      submit: "Send",
      success: "Message sent! We'll get back to you.",
    },
    cookies: {
      text: "We use cookies to improve your experience.",
      accept: "Accept",
      decline: "Decline",
    },
  },

  pl: {
    nav: { program: "Program", speakers: "Prelegenci", gallery: "Zdjęcia", pricing: "Bilety", buy: "Kup bilet", contact: "Kontakt" },
    footer: {
      contacts: "Kontakt",
      docs: "Dokumenty",
      refund: "Polityka zwrotów",
      terms: "Regulamin",
      privacy: "Polityka prywatności",
      made: "Zrobione z miłości do networkingu.",
    },
    modal: {
      title: "Rejestracja na konferencję",
      desc: "Wypełnij dane — po opłaceniu trafisz do zamkniętego czatu uczestników.",
      l_name: "Imię i nazwisko", p_name: "Jan Kowalski",
      l_phone: "Telefon", p_phone: "+48 600 000 000",
      l_tg: "Telegram @username", p_tg: "@username", help_tg: "Potrzebny do dodania Cię do zamkniętego czatu uczestników.",
      l_ticket: "Kategoria biletu",
      total: "Razem",
      pay_note: "Płatność kartą przez Stripe. Bezpiecznie i szyfrowane.",
      agree: "Akceptuję regulamin, politykę zwrotów oraz przetwarzanie danych osobowych.",
      pay_btn: "Przejdź do bezpiecznej płatności",
      pay_loading: "Przekierowanie do płatności...",
      err_name: "Podaj imię i nazwisko",
      err_phone: "Podaj poprawny numer telefonu",
      err_tg: "Podaj swój Telegram @username",
      err_agree: "Zaakceptuj politykę",
      err_generic: "Coś poszło nie tak",
    },
    toasts: {
      cancel: "Płatność anulowana. Spróbuj ponownie.",
      success: "Płatność udana! Do zobaczenia na konferencji 🎉",
      expired: "Sesja płatności wygasła. Spróbuj ponownie.",
      check: "Sprawdzamy status płatności...",
      manual: "Nie udało się automatycznie potwierdzić płatności. Sprawdź email.",
    },
    lang: { label: "Język" },
    contact: {
      eyebrow: "Kontakt",
      title: "Skontaktuj się z nami",
      l_name: "Imię i nazwisko",
      p_name: "Jan Kowalski",
      l_phone: "Telefon",
      p_phone: "+48 600 000 000",
      l_email: "Email",
      p_email: "jan@example.com",
      l_message: "Pytanie / komentarz",
      p_message: "Twoje pytanie...",
      submit: "Wyślij",
      success: "Wiadomość wysłana! Skontaktujemy się z Tobą.",
    },
    cookies: {
      eyebrow: "Cookies",
      text: "Używamy plików cookies, aby poprawić działanie strony.",
      accept: "Akceptuję",
      decline: "Odrzucam",
    },
  },
};

function deepMerge(target, source) {
  const output = { ...(target || {}) };
  if (source && typeof source === "object" && !Array.isArray(source)) {
    Object.keys(source).forEach((key) => {
      if (source[key] && typeof source[key] === "object" && !Array.isArray(source[key])) {
        if (!(key in output)) {
          output[key] = source[key];
        } else {
          output[key] = deepMerge(output[key], source[key]);
        }
      } else {
        output[key] = source[key];
      }
    });
  }
  return output;
}

const TRANSLATIONS = {};
const allLangs = Array.from(new Set([...Object.keys(BASE_TRANSLATIONS), ...Object.keys(EVENT_TRANSLATIONS || {})]));
for (const lang of allLangs) {
  TRANSLATIONS[lang] = deepMerge(BASE_TRANSLATIONS[lang] || {}, (EVENT_TRANSLATIONS && EVENT_TRANSLATIONS[lang]) || {});
}

const DEFAULT_LANG = (LANGS && LANGS[0] && LANGS[0].code) || "ru";

const LangContext = createContext({ lang: DEFAULT_LANG, setLang: () => {}, t: (k) => k });

function getByPath(obj, path) {
  return path.split(".").reduce((o, k) => (o && o[k] !== undefined ? o[k] : undefined), obj);
}

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    if (typeof window === "undefined") return DEFAULT_LANG;
    const saved = localStorage.getItem("lang");
    if (saved && TRANSLATIONS[saved]) return saved;
    const nav = (navigator.language || DEFAULT_LANG).slice(0, 2).toLowerCase();
    return TRANSLATIONS[nav] ? nav : DEFAULT_LANG;
  });

  useEffect(() => {
    try { localStorage.setItem("lang", lang); } catch (_) {}
    if (typeof document !== "undefined") document.documentElement.lang = lang;
  }, [lang]);

  const setLang = (l) => { if (TRANSLATIONS[l]) setLangState(l); };

  const value = useMemo(() => {
    const dict = TRANSLATIONS[lang];
    const t = (key) => {
      const v = getByPath(dict, key);
      return v === undefined ? key : v;
    };
    return { lang, setLang, t };
  }, [lang]);

  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
}

export function useT() {
  const ctx = useContext(LangContext);
  return ctx;
}
